<template>
  <div class="container">
    <div class="columns is-centered">
      <div class="column is-4">
        <div class="tabs">
          <ul>
            <li>
              Reset Password
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="columns is-centered">
      <div class="column is-4">
        <div class="field">
          <label class="label">Email</label>
          <div class="control">
            <input
              :value="$route.query.email"
              class="input"
              type="text"
              disabled
              placeholder="Email"
            >
          </div>
        </div>

        <div class="field">
          <label class="label">New Password</label>
          <div class="control">
            <input
              v-model="$v.password.$model"
              class="input"
              v-bind:class="{ 'is-danger': $v.password.$error }"
              type="password"
              placeholder="Password"
            >
            <p v-if="$v.password.$error" class="help is-danger">This value is invalid</p>
          </div>
        </div>

        <div class="field">
          <label class="label">Confirm Password</label>
          <div class="control">
            <input
              v-model="$v.password_confirmation.$model"
              class="input"
              v-bind:class="{ 'is-danger': $v.password_confirmation.$error }"
              type="password"
              placeholder="Confirm Password"
            >
            <p
              v-if="$v.password_confirmation.$error"
              class="help is-danger"
            >This value is invalid</p>
          </div>
        </div>

        <div class="field">
          <div class="buttons">
            <button
              class="button is-primary"
              type="submit"
              @click.prevent="submitPasswordReset"
              :disabled="$v.$invalid"
            >
              Reset Password
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, sameAs, minLength } from 'vuelidate/lib/validators';
import UPDATE_FORGOTTEN_PASSWORD from '@/graphql/user/updateForgottenPassword.gql';

export default {
  name: 'PasswordReset',
  data() {
    return {
      password: '',
      password_confirmation: '',
    };
  },
  validations: {
    password: {
      required,
      minLength: minLength(8),
    },
    password_confirmation: {
      required,
      sameAsPassword: sameAs('password'),
    },
  },
  methods: {
    submitPasswordReset() {
      this.$apollo.mutate({
        mutation: UPDATE_FORGOTTEN_PASSWORD,
        variables: {
          email: this.$route.query.email,
          token: this.$route.params.token,
          password: this.password,
          passwordConfirmation: this.password_confirmation,
        },
      })
        .then(() => {
          this.$toasted.success('Password updated');
          this.$router.push({ name: 'home' });
        })
        .catch((err) => {
          this.$toasted.error(err);
        });
    },
  },
};
</script>

<style scoped>

</style>
